var makeRequestContext = function(context) {
  var baseSSRContext = context.ssrContext;
  var requestContext = baseSSRContext ? {
    isBrowser: context.isBrowser,
    request: baseSSRContext.request || {},
    response: baseSSRContext.response || {},
    logger: baseSSRContext.logger || {}
  } : {};
  return requestContext;
};
var requestContextPlugin = function() {
  return {
    name: "@modern-js/runtime-plugin-request-context",
    setup: function setup(api) {
      api.onBeforeRender(function(context) {
        var requestContext = makeRequestContext(context);
        context.context = requestContext;
      });
    }
  };
};
export {
  makeRequestContext,
  requestContextPlugin
};
